// reducers/groupModalReducer.js

const initialState = {
    groupModalOpen: false,
};

const groupModalReducer = (state = initialState, action) => {
    switch (action.type) {
        case "SET_GROUP_MODAL_OPEN":
            return { ...state, groupModalOpen: true };

        case "SET_GROUP_MODAL_CLOSE":
            return { ...state, groupModalOpen: false };

        default:
            return state;
    }
};

export default groupModalReducer;
